"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Radar } from "lucide-react";
const trendingHashtags = [{
  label: "SeasonalBlooms",
  url: "/ShopPage"
}, {
  label: "GardenWeddings",
  url: "/EventServicesPage"
}, {
  label: "SustainableFloral",
  url: "/TheGardenPage"
}, {
  label: "BespokeDesign",
  url: "/EventServicesPage"
}, {
  label: "PetalArtistry",
  url: "/TheGardenPage"
}];
export default function TrendRadarHero() {
  return <section data-section-id="229314" id="bespoke-event-design" className="bg-background text-foreground relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden py-[100px]">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes radar-expand {
          0% { transform: scale(0); opacity: 0.8; }
          100% { transform: scale(4); opacity: 0; }
        }
        .animate-radar-1 { animation: radar-expand 4s linear infinite; }
        .animate-radar-2 { animation: radar-expand 4s linear infinite 1.3s; }
        .animate-radar-3 { animation: radar-expand 4s linear infinite 2.6s; }
        
        @keyframes glitch-anim-1 {
          0% { clip-path: inset(20% 0 80% 0); transform: translate(-2px, 1px); }
          20% { clip-path: inset(60% 0 10% 0); transform: translate(2px, -1px); }
          40% { clip-path: inset(40% 0 50% 0); transform: translate(-2px, 2px); }
          60% { clip-path: inset(80% 0 5% 0); transform: translate(2px, -2px); }
          80% { clip-path: inset(10% 0 70% 0); transform: translate(-1px, 1px); }
          100% { clip-path: inset(30% 0 50% 0); transform: translate(1px, -1px); }
        }
        @keyframes glitch-anim-2 {
          0% { clip-path: inset(10% 0 60% 0); transform: translate(2px, -1px); }
          20% { clip-path: inset(30% 0 20% 0); transform: translate(-2px, 1px); }
          40% { clip-path: inset(70% 0 10% 0); transform: translate(2px, -2px); }
          60% { clip-path: inset(20% 0 50% 0); transform: translate(-2px, 2px); }
          80% { clip-path: inset(50% 0 30% 0); transform: translate(1px, -1px); }
          100% { clip-path: inset(5% 0 80% 0); transform: translate(-1px, 1px); }
        }
        .glitch-wrapper {
          position: relative;
          display: inline-block;
        }
        .glitch-text::before,
        .glitch-text::after {
          content: attr(data-text);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: var(--background);
        }
        .glitch-text::before {
          left: 3px;
          text-shadow: -2px 0 var(--primary);
          animation: glitch-anim-1 2.5s infinite linear alternate-reverse;
          z-index: -1;
        }
        .glitch-text::after {
          left: -3px;
          text-shadow: 2px 0 var(--secondary);
          animation: glitch-anim-2 3s infinite linear alternate-reverse;
          z-index: -2;
        }
      `
    }} />

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        <div className="absolute size-[200px] rounded-lg border border-primary/40 animate-radar-1" />
        <div className="absolute size-[200px] rounded-lg border border-primary/30 animate-radar-2" />
        <div className="absolute size-[200px] rounded-lg border border-primary/20 animate-radar-3" />
        
        {}
        <div className="absolute size-4 rounded-lg bg-primary shadow-md" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_10%,transparent_100%)] opacity-10" />
      </div>

      {}
      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center px-6 text-center">
        <div className="mb-6 flex items-center justify-center rounded-lg border border-primary/30 bg-primary/5 p-3 text-primary backdrop-blur-sm">
          <Radar className="size-8 animate-pulse" />
        </div>
        
        <h1 className="glitch-wrapper mb-6 font-serif text-5xl font-bold tracking-tight uppercase md:text-7xl lg:text-8xl">
          <span className="glitch-text relative inline-block text-transparent bg-clip-text bg-gradient-to-r from-primary via-foreground to-accent-foreground" data-text="PETAL DESIGN">
            PETAL DESIGN
          </span>
        </h1>
        
        <p className="mb-10 max-w-2xl text-lg text-muted-foreground font-default md:text-xl">
          Unforgettable moments, naturally grown. We cultivate the finest seasonal blooms to transform your special events into living art.
        </p>

        <div className="flex flex-col items-center space-y-4">
          <span className="text-sm font-semibold tracking-widest text-primary uppercase font-default">
            Our Specialties
          </span>
          <div className="flex flex-wrap justify-center gap-3">
            {trendingHashtags.map((tag, i) => <Link key={i} to={tag.url} data-index={i}>
                <Badge variant="outline" className="cursor-pointer border-primary/20 bg-background/40 px-4 py-2 text-sm font-default backdrop-blur-md transition-all hover:scale-105 hover:border-primary hover:bg-primary/10 hover:text-primary hover:shadow-md">
                  #{tag.label}
                </Badge>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}